import { useEffect } from 'react';
import { api } from '../services/api';

export function Analytics() {
  useEffect(() => {
    // Capture UTM parameters from URL and store them
    const captureUTMs = () => {
      const params = new URLSearchParams(window.location.search);
      const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'ref'];
      
      let hasUTMs = false;
      utmParams.forEach(param => {
        const value = params.get(param);
        if (value) {
          sessionStorage.setItem(param, value);
          hasUTMs = true;
        }
      });

      // If we found UTMs, we might want to store the landing page too
      if (hasUTMs && !sessionStorage.getItem('landing_page')) {
        sessionStorage.setItem('landing_page', window.location.pathname);
      }
    };

    captureUTMs();

    let mounted = true;

    const initAnalytics = async () => {
      try {
        const settings = await api.getSettings();
        if (!mounted) return;

        // Inject Google Analytics
        if (settings.GA_ID && !document.getElementById('ga-script')) {
          const script1 = document.createElement('script');
          script1.id = 'ga-script';
          script1.async = true;
          script1.src = `https://www.googletagmanager.com/gtag/js?id=${settings.GA_ID}`;
          document.head.appendChild(script1);

          const script2 = document.createElement('script');
          script2.id = 'ga-init';
          script2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${settings.GA_ID}');
          `;
          document.head.appendChild(script2);
        }

        // Inject Meta Pixel (Facebook Pixel)
        if (settings.META_PIXEL_ID && !document.getElementById('meta-pixel-script')) {
          const script = document.createElement('script');
          script.id = 'meta-pixel-script';
          script.innerHTML = `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${settings.META_PIXEL_ID}');
            fbq('track', 'PageView');
          `;
          document.head.appendChild(script);
        }

        // Inject Google Search Console Verification
        if (settings.GSC_VERIFICATION && !document.querySelector('meta[name="google-site-verification"]')) {
          const meta = document.createElement('meta');
          meta.name = 'google-site-verification';
          meta.content = settings.GSC_VERIFICATION;
          document.head.appendChild(meta);
        }
      } catch (error) {
        // Fallback gracefully without logging console error in static CDN mode
      }
    };

    initAnalytics();

    return () => {
      mounted = false;
    };
  }, []);

  return null;
}
